import { IndexSection } from "../store/product-index/state";

export function anySatisfies<T>(
    array: T[],
    predicate: (el: T) => boolean,
): boolean {
    return array.map(predicate).reduce((a, b) => a || b, false);
}

export function allSatisfy<T>(
    array: T[],
    predicate: (el: T) => boolean,
): boolean {
    return array.map(predicate).reduce((a, b) => a && b, true);
}

export function relink<T>(update: T, base: T): T {
    return relinkInt(update, base)[0];
}

function relinkInt<T>(update: T, base: T): [T, boolean] {
    if (typeof update !== "object" || update == null) {
        return [update, update !== base];
    }
    if (base == null) {
        return [update, true];
    }

    let changed = false;
    const updateKeys = Object.keys(update);
    if (updateKeys.length !== Object.keys(base).length) {
        changed = true;
    }

    let merged: T;
    if (Array.isArray(update)) {
        merged = [] as any as T;
    } else {
        merged = {} as T;
    }
    updateKeys.forEach((key) => {
        const [value, valueChanged] = relinkInt(update[key], base[key]);
        merged[key] = valueChanged ? value : base[key];
        changed = changed || valueChanged;
    });
    return [changed ? merged : base, changed];
}

export function trackEntity(index: number, item: any): string {
    return item.Id;
}

export function trackIndex(index: number): string {
    return index.toString();
}

export function trackIndexSection(index: number, item: IndexSection): string {
    return item.name.key;
}

export function updateArrayAt<T>(array: T[], index: number, replacement: T) {
    return [...array.slice(0, index), replacement, ...array.slice(index + 1)];
}

export function copyCanvasContent(
    from: HTMLCanvasElement,
    to: HTMLCanvasElement,
): void {
    const ctx = to.getContext("2d");
    ctx.drawImage(from, 0, 0);
}

export function isNullUndefinedOrEmptyString(value: any): boolean {
    return value === undefined || value === null || value === "";
}
